// extracted by mini-css-extract-plugin
export var barChart = "styles-module--barChart--233d1";
export var container = "styles-module--container--9f4b2";
export var legendContainer = "styles-module--legendContainer--35fe8";
export var lineGraph = "styles-module--lineGraph--befaf";
export var noDisplay = "styles-module--noDisplay--0c9af";
export var pieChart = "styles-module--pieChart--d3dac";
export var statisticsFlex = "styles-module--statisticsFlex--17356";
export var statisticsGrid = "styles-module--statisticsGrid--64548";
export var statisticsTile = "styles-module--statisticsTile--c5f61";
export var statisticsTileValue = "styles-module--statisticsTileValue--c2b50";
export var subtitleContainer = "styles-module--subtitleContainer--fcab9";
export var titleContainer = "styles-module--titleContainer--d8b52";